/**
 * The parts of the Ad connections screen that are rules rather than rendering.
 */

/**
 * Where the API answers, as an origin. The ad platforms are given full addresses, so a
 * relative base - the dev server's proxy, or an API served from the same origin - is
 * resolved against the page.
 */
export function apiOrigin(base: string, pageOrigin: string): string {
  const withoutPrefix = base.replace(/\/api\/v1\/?$/, '')
  return /^https?:\/\//i.test(withoutPrefix) ? withoutPrefix.replace(/\/+$/, '') : pageOrigin.replace(/\/+$/, '')
}

/** A full webhook address for a path the API gave. */
export function webhookUrl(base: string, pageOrigin: string, path: string): string {
  return apiOrigin(base, pageOrigin) + (path.startsWith('/') ? path : `/${path}`)
}

export type TestState = { tone: 'positive' | 'warning'; text: string }

/**
 * Whether Google's "Send test data" has reached a source. Until it has, nobody knows the
 * address and key were pasted in correctly, so the screen says what to press.
 */
export function googleTestState(lastTestAt: string | null, format: (iso: string) => string): TestState {
  return lastTestAt
    ? { tone: 'positive', text: `Test received ${format(lastTestAt)}` }
    : { tone: 'warning', text: 'No test received yet - press Send test data in Google Ads' }
}

/** "1 lead waiting", "3 leads waiting", nothing at zero. */
export function waitingLabel(count: number): string | null {
  if (count <= 0) return null
  return `${count} ${count === 1 ? 'lead' : 'leads'} waiting`
}
